export default "__VITE_ASSET__7c8c9c80__"